<template>
  <div class="bg-(--ui-bg)">
    <div class="mx-auto px-2 py-2">
      <div class="grid grid-cols-1 xl:grid-cols-12 xl:grid-rows-[auto_1fr] gap-3">
        <div class="order-2 xl:order-none xl:col-span-8 xl:col-start-1 xl:row-start-1 xl:row-span-2 space-y-3">
          <div class="relative">
            <!--
            <div class="absolute top-0 left-3 z-[1] flex items-center gap-1.5 px-2.5 py-1 bg-primary-50 dark:bg-primary-900/50 ring-1 ring-primary-400 dark:ring-primary-500 rounded-full shadow-sm">
              <UIcon name="i-heroicons-clipboard-document-list" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400"/>
              <span class="text-xs font-semibold text-primary-700 dark:text-primary-300 whitespace-nowrap">{{ t('workflowDetail.overview.contractSectionTitle') }}</span>
            </div>
            -->
            <UCard class="overflow-hidden shadow-md border-0 border-l-3 border-l-primary-400 dark:border-l-primary-500 bg-(--ui-bg)/90 backdrop-blur-sm" :ui="{ root: 'divide-none shadow-xs', body: 'p-2 sm:p-2' }">
            <div class="mb-2">
              <div class="flex flex-col md:flex-row gap-2 md:justify-center">
                <div v-if="workflow.purchaseOrders?.[purchaseOrderIndex]?.type !== PurchaseOrder.Tyre && (props.isPublicView || [Permission.CustomerCare, Permission.Driver, Permission.HR, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.Dealer, Permission.VehicleSupplier, Permission.SupplierSuperUser, Permission.PurchaseSupport].some(p => userStore.hasPermission(p)))" class="md:flex-1 bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 rounded-lg p-2.5">
                  <h3 class="text-sm font-medium text-blue-700 dark:text-blue-300 mb-2 text-center">{{ t('workflowDetail.overview.investmentPrice') }}</h3>
                  <div v-if="workflow?.tenant === Tenant.CZ" class="flex justify-center gap-14">
                    <div class="text-center">
                      <div class="text-xs font-medium text-blue-600 dark:text-blue-400 mb-0">{{ t('workflowDetail.common.exclVat') }}</div>
                      <div class="text-lg font-semibold text-blue-900 dark:text-blue-100">{{ workflow.quotation?.financials?.calculationBase ? formatPriceWithCurrency(workflow.quotation?.financials?.calculationBase, workflow.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                    </div>
                    <div class="text-center">
                      <div class="text-xs font-medium text-blue-600 dark:text-blue-400 mb-0">{{ t('workflowDetail.common.inclVat') }}</div>
                      <div class="text-lg font-semibold text-blue-900 dark:text-blue-100">{{ workflow.quotation?.financials?.calculationBase ? formatPriceWithCurrency(workflow.quotation?.financials?.calculationBase * 1.21, workflow.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                    </div>
                  </div>
                  <div v-else class="flex justify-center gap-14">
                    <div class="text-center">
                      <div class="text-xs font-medium text-blue-600 dark:text-blue-400 mb-0">{{ t('workflowDetail.common.exclVat') }}</div>
                      <div class="text-lg font-semibold text-blue-900 dark:text-blue-100">{{ workflow.quotation?.financials?.investment ? formatPriceWithCurrency(workflow.quotation?.financials?.investment, workflow.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                    </div>
                    <div class="text-center">
                      <div class="text-xs font-medium text-blue-600 dark:text-blue-400 mb-0">{{ t('workflowDetail.common.inclVat') }}</div>
                      <div class="text-lg font-semibold text-blue-900 dark:text-blue-100">{{ workflow.quotation?.financials?.investmentInclVat ? formatPriceWithCurrency(workflow.quotation?.financials?.investmentInclVat, workflow.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                    </div>
                  </div>
                </div>
                
                <div v-if="props.isPublicView || [Permission.CustomerCare, Permission.Driver, Permission.HR, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))" class="md:flex-1 bg-gradient-to-br from-emerald-50 to-emerald-100 dark:from-emerald-900/30 dark:to-emerald-800/30 rounded-lg p-2.5">
                  <h3 class="text-sm font-medium text-emerald-700 dark:text-emerald-300 mb-2 text-center">{{ t('workflowDetail.overview.monthlyPayment') }}</h3>
                  <div v-if="workflow?.tenant === Tenant.CZ" class="flex justify-center gap-14">
                    <div class="text-center">
                      <div class="text-xs font-medium text-emerald-600 dark:text-emerald-400 mb-0">{{ t('workflowDetail.common.exclVat') }}</div>
                      <div class="text-lg font-semibold text-emerald-900 dark:text-emerald-100">{{ workflow.quotation?.financials?.monthlyRate ? formatPriceWithCurrency(workflow.quotation?.financials?.monthlyRate, workflow.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                    </div>
                    <div class="text-center">
                      <div class="text-xs font-medium text-emerald-600 dark:text-emerald-400 mb-0">{{ t('workflowDetail.common.inclVat') }}</div>
                      <div class="text-lg font-semibold text-emerald-900 dark:text-emerald-100">{{ workflow.quotation?.financials?.monthlyRate ? formatPriceWithCurrency(workflow.quotation?.financials?.monthlyRate * 1.21, workflow.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                    </div>
                  </div>
                  <div v-else class="flex justify-center gap-14">
                    <div class="text-center">
                      <div class="text-xs font-medium text-emerald-600 dark:text-emerald-400 mb-0">{{ t('workflowDetail.common.exclVat') }}</div>
                      <div class="text-lg font-semibold text-emerald-900 dark:text-emerald-100">{{ workflow.quotation?.financials?.monthlyRate ? formatPriceWithCurrency(workflow.quotation?.financials?.monthlyRate, workflow.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                    </div>
                    <div class="text-center">
                      <div class="text-xs font-medium text-emerald-600 dark:text-emerald-400 mb-0">{{ t('workflowDetail.common.inclVat') }}</div>
                      <div class="text-lg font-semibold text-emerald-900 dark:text-emerald-100">{{ workflow.quotation?.financials?.monthlyRateInclVat ? formatPriceWithCurrency(workflow.quotation?.financials?.monthlyRateInclVat, workflow.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="flex flex-wrap gap-2 mb-2">
              <div v-if="workflow.purchaseOrders?.[purchaseOrderIndex]?.type !== PurchaseOrder.Tyre && (props.isPublicView || [Permission.CustomerCare, Permission.Driver, Permission.HR, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p)))" class="flex-1 min-w-[200px] group px-2.5 py-2 bg-gradient-to-br from-rose-50 to-rose-100 dark:from-rose-900/30 dark:to-rose-800/30 rounded-lg">
                <div class="flex items-center gap-2 mb-2">
                  <UIcon name="i-mdi-calendar-clock" class="w-4 h-4 text-rose-600 dark:text-rose-400"/>
                  <span class="text-xs font-medium text-rose-600 dark:text-rose-400">{{ t('workflowDetail.contract.duration') }}</span>
                </div>
                <div class="flex items-baseline gap-1">
                  <span class="text-xl font-semibold text-rose-600 dark:text-rose-400">{{ workflow.quotation?.financials?.duration  || '-' }}</span>
                  <span class="text-sm font-medium text-rose-500 dark:text-rose-300">{{ t('workflowDetail.common.months') }}</span>
                </div>
              </div>
              
              <div v-if="workflow.purchaseOrders?.[purchaseOrderIndex]?.type !== PurchaseOrder.Tyre && (props.isPublicView || [Permission.CustomerCare, Permission.Driver, Permission.HR, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p)))" class="flex-1 min-w-[200px] group px-2.5 py-2 rounded-lg bg-gradient-to-br from-teal-50 to-teal-100 dark:from-teal-900/30 dark:to-teal-800/30">
                <div class="flex items-center gap-2 mb-2">
                  <UIcon name="i-mdi-speedometer" class="w-4 h-4 text-teal-600 dark:text-teal-400"/>
                  <span class="text-xs font-medium text-teal-700 dark:text-teal-300">{{ t('workflowDetail.contract.mileage') }}</span>
                </div>
                <div v-if="workflow.tenant === Tenant.FI" class="flex items-baseline gap-1">
                  <span class="text-xl font-semibold text-teal-900 dark:text-teal-100">{{ formatNumber(workflow.quotation?.financials?.mileage) || '-' }}</span>
                  <span class="text-sm font-medium text-teal-700 dark:text-teal-300">km</span>
                </div>
                <div v-else class="flex justify-between text-teal-900 dark:text-teal-100">
                  <div class="flex flex-col items-start">
                    <div class="text-base font-semibold">{{ formatNumber(workflow.quotation?.financials?.mileage) || '-' }}<span class="text-sm font-medium ml-1">km</span></div>
                    <div class="text-xs text-teal-600 dark:text-teal-400">{{ t('workflowDetail.common.annual') }}</div>
                  </div>
                  <div class="flex flex-col items-end">
                    <div class="text-base font-semibold">{{ workflow.quotation?.financials?.mileage ? formatNumber(workflow.quotation?.financials?.mileage * (workflow.quotation?.financials?.duration / 12)) : '-' }}<span class="text-sm font-medium ml-1">km</span></div>
                    <div class="text-xs text-teal-600 dark:text-teal-400">{{ t('workflowDetail.common.total') }}</div>
                  </div>
                </div>
              </div>
              
              <div class="flex-1 min-w-[200px] group px-2.5 py-2 rounded-lg bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/30 dark:to-purple-800/30">
                <div class="flex items-center gap-2 mb-2">
                  <UIcon name="i-mdi-car-info" class="w-4 h-4 text-purple-600 dark:text-purple-400"/>
                  <span class="text-xs font-medium text-purple-700 dark:text-purple-300">{{ t('workflowDetail.vehicle.vin') }}</span>
                </div>
                <div class="space-y-1">
                  <!--
                  <UInput
                    v-if="props.isEditMode && [Permission.Dealer, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))"
                    v-model="workflowEditStore.editableWorkflow.delivery.vin"
                    color="neutral"
                    highlight
                    placeholder="VIN"
                    size="sm"
                    class="font-mono text-xs"
                    :maxlength="17"
                    :ui="{ base: 'uppercase text-xs h-8' }"
                  >
                    <template #trailing>
                      <div id="character-count" class="text-xs text-muted tabular-nums">
                        {{ workflowEditStore.editableWorkflow.delivery.vin?.length }}/{{ 17 }}
                      </div>
                    </template>
                  </UInput>
                  <div v-else class="min-h-[24px] flex items-center">
                    <p class="text-base font-mono font-semibold text-purple-900 dark:text-purple-100 uppercase h-8">
                      {{ workflowEditStore.editableWorkflow?.delivery.vin || '-' }}
                    </p>
                  </div>
                  -->
                  <div class="h-8 flex items-center">
                    <p class="text-base font-mono font-semibold text-purple-900 dark:text-purple-100 uppercase">
                      {{ workflowEditStore.editableWorkflow?.delivery?.vin || '-' }}
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="isSapOrder(workflow.purchaseOrders?.[purchaseOrderIndex]) || isNolsOrder(workflow.purchaseOrders?.[purchaseOrderIndex])" class="flex-1 min-w-[200px] group px-2.5 py-2 rounded-lg bg-gradient-to-br from-orange-50 to-orange-100 dark:from-orange-900/30 dark:to-orange-800/30">
                <div class="flex items-center gap-2 mb-2">
                  <UIcon name="i-heroicons-calendar-days" class="w-4 h-4 text-orange-600 dark:text-orange-400"/>
                  <span class="text-xs font-medium text-orange-700 dark:text-orange-300">{{ t('workflowDetail.contract.dealerExpectedDeliveryDate') }}</span>
                </div>
                <div class="space-y-1">
                  <UPopover v-if="props.isEditMode && !isWorkflowFinal && workflow.purchaseOrders && workflow.purchaseOrders.length > 0 && isVehicleOrderType(workflow.purchaseOrders?.[purchaseOrderIndex]?.type) && [Permission.VehicleSupplier, Permission.SupplierSuperUser, Permission.Dealer, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))" v-model:open="isDealerExpectedDeliveryDatePopoverOpen">
                    <UButton
                      color="neutral"
                      variant="outline"
                      class="w-40 h-8 text-sm justify-start cursor-pointer text-left focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-inverted ring ring-inset ring-inverted"
                      :class="[dealerExpectedDeliveryDate ? '' : 'text-dimmed', showExpectedDeliveryDateInvalidError ? 'ring-orange-500 border-orange-500' : '']"
                    >
                      <UIcon name="i-lucide-calendar" class="w-4 h-4 mr-0.5"/>
                      {{ dealerExpectedDeliveryDate ? formatDate(dealerExpectedDeliveryDate, 'short', locale) : t('workflowDetail.common.select')  }}
                    </UButton>
                    <template #content>
                      <UCalendar v-model="dealerExpectedDeliveryDate" :locale="locale" :min-value="dealerExpectedDeliveryDateMinDate" :is-date-disabled="dealerExpectedDeliveryDateDisabledDates" :year-controls="false" @update:model-value="isDealerExpectedDeliveryDatePopoverOpen = false" />
                    </template>
                  </UPopover>
                  <div v-else class="h-8 flex items-center">
                    <p class="text-base font-mono font-semibold text-orange-900 dark:text-orange-100 uppercase">
                      {{ workflowEditStore.editableWorkflow?.purchaseOrders?.[purchaseOrderIndex]?.dealerExpectedDeliveryDate ? formatDate(workflowEditStore.editableWorkflow.purchaseOrders[purchaseOrderIndex].dealerExpectedDeliveryDate, 'short', locale) : '-' }}
                    </p>
                  </div>
                  
                  <div v-if="showExpectedDeliveryDateInvalidError" class="mt-1 p-2.5 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
                    <div class="flex items-start gap-2">
                      <UIcon name="i-heroicons-exclamation-circle" class="w-4.5 h-4.5 text-red-500 flex-shrink-0 mt-0.5" />
                      <div class="text-[0.8rem] text-red-700 dark:text-red-300 leading-tight">
                        <p class="font-medium mb-0.5">{{ t('processStatus.expectedDeliveryDateInvalidTitle') }}</p>
                        <p>{{ t('processStatus.expectedDeliveryDateInvalidMessage') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-if="workflow.purchaseOrders?.[purchaseOrderIndex]?.type === PurchaseOrder.Tyre && workflow.purchaseOrders?.[purchaseOrderIndex]?.deliveryDate" class="flex-1 min-w-[200px] group px-2.5 py-2 rounded-lg bg-gradient-to-br from-cyan-50 to-cyan-100 dark:from-cyan-900/30 dark:to-cyan-800/30">
                <div class="flex items-center gap-2 mb-2">
                  <UIcon name="i-lucide-calendar" class="w-4 h-4 text-cyan-600 dark:text-cyan-400"/>
                  <span class="text-xs font-medium text-cyan-700 dark:text-cyan-300">{{ t('workflowDetail.contract.secondTyreSetStorageDate') }}</span>
                </div>
                <div class="min-h-[24px] flex items-center">
                  <p class="text-base font-semibold text-cyan-900 dark:text-cyan-100 h-8 flex items-center">
                    {{ formatDate(workflow.purchaseOrders[purchaseOrderIndex].deliveryDate, 'short', locale) }}
                  </p>
                </div>
              </div>
              
              <div v-if="workflow.purchaseOrders?.[purchaseOrderIndex]?.type === PurchaseOrder.Tyre && workflow.purchaseOrders?.[purchaseOrderIndex]?.tyreLocationAddress" class="flex-1 min-w-[200px] group px-2.5 py-2 rounded-lg bg-gradient-to-br from-cyan-50 to-cyan-100 dark:from-cyan-900/30 dark:to-cyan-800/30">
                <div class="flex items-center gap-2 mb-2">
                  <UIcon name="i-heroicons-map-pin" class="w-4 h-4 text-cyan-600 dark:text-cyan-400"/>
                  <span class="text-xs font-medium text-cyan-700 dark:text-cyan-300">{{ t('workflowDetail.contract.secondTyreSetStorageAddress') }}</span>
                </div>
                <div class="min-h-[24px] flex items-center">
                  <p class="text-base font-semibold text-cyan-900 dark:text-cyan-100 h-8 line-clamp-2 leading-tight flex items-center">
                    {{ workflow.purchaseOrders?.[purchaseOrderIndex]?.tyreLocationAddress }}
                  </p>
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2.5">
              <div v-if="workflow?.tenant === Tenant.CZ && workflow.purchaseOrders?.[purchaseOrderIndex]?.type !== PurchaseOrder.Tyre" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-question-mark-circle" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ t('workflowDetail.contract.meaningOfReqDeliveryDate') }}
                </label>
                <USelect
                  v-if="props.isEditMode && workflowEditStore.editableWorkflow?.quotation && [Permission.ClientAccount, Permission.KeyAccountManager, Permission.Backoffice, Permission.FleetManager, Permission.Driver, Permission.HR].some(p => userStore.hasPermission(p))"
                  v-model="(workflowEditStore.editableWorkflow!.quotation!.requestedDeliveryDateScenario ??= {}).mode"
                  :items="[
                    { label: t('workflowDetail.meaningDeliveryDate.asap'), value: 'ASAP' },
                    { label: t('workflowDetail.meaningDeliveryDate.onDate'), value: 'EQ' },
                    { label: t('workflowDetail.meaningDeliveryDate.afterDate'), value: 'GE' },
                    { label: t('workflowDetail.meaningDeliveryDate.beforeDate'), value: 'LE' }
                  ]"
                  color="neutral"
                  highlight
                  size="sm"
                  class="mt-0 w-40"
                  :ui="{ base: 'text-sm h-8' }"
                />
                <p v-else class="text-sm font-semibold text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ ({ ASAP: t('workflowDetail.meaningDeliveryDate.asap'), EQ: t('workflowDetail.meaningDeliveryDate.onDate'), GE: t('workflowDetail.meaningDeliveryDate.afterDate'), LE: t('workflowDetail.meaningDeliveryDate.beforeDate') }[workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario?.mode] ?? '-') }}
                </p>
              </div>
              
              <div v-if="workflow.purchaseOrders?.[purchaseOrderIndex]?.type !== PurchaseOrder.Tyre" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-calendar" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ workflow?.tenant === Tenant.CZ ? t('workflowDetail.contract.requiredDeliveryDate') : t('workflowDetail.contract.possibleDeliveryDate') }}
                </label>
                <UPopover v-if="props.isEditMode && workflowEditStore.editableWorkflow?.quotation && [Permission.CustomerCare, Permission.ClientAccount, Permission.KeyAccountManager, Permission.Backoffice, Permission.FleetManager, Permission.Driver, Permission.HR].some(p => userStore.hasPermission(p)) && (workflow?.tenant === Tenant.FI && !workflowEditStore.editableWorkflow!.quotation!.requestedDeliveryDateScenario?.mode || ['LE','GE','EQ'].includes((workflowEditStore.editableWorkflow!.quotation!.requestedDeliveryDateScenario ??= {}).mode))" v-model:open="isRequiredDeliveryDatePopoverOpen">
                  <UButton
                    color="neutral"
                    variant="outline"
                    class="w-40 h-8 text-sm justify-start cursor-pointer text-left focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-inverted ring ring-inset ring-inverted"
                    :class="[
                      requiredDeliveryDate ? '' : 'text-dimmed',
                      requestedDeliveryDateValidationError ? 'border-red-600 ring-red-600' : ''
                    ]"
                  >
                    <UIcon name="i-lucide-calendar" class="w-4 h-4 mr-0.5"/>
                    {{ requiredDeliveryDate ? formatDate(requiredDeliveryDate, 'short', locale) : t('workflowDetail.common.select')  }}
                  </UButton>
                  <template #content>
                    <UCalendar v-model="requiredDeliveryDate" :locale="locale" :min-value="requiredDeliveryDateMinDate" :is-date-disabled="requiredDeliveryDateDisabledDates" :year-controls="false" @update:model-value="isRequiredDeliveryDatePopoverOpen = false" />
                  </template>
                </UPopover>
                <p v-else class="text-sm font-semibold text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ ['LE','GE','EQ'].includes(workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario?.mode) && workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario?.date ? formatDate(workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario?.date, 'short', locale) : '-' }}
                </p>
                <p v-if="props.isEditMode && requestedDeliveryDateValidationError" class="mt-1 text-xs text-red-600 dark:text-red-400">
                  {{ t('notification.requestedDeliveryDateValidationError') }}
                </p>
              </div>
              
              <div class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-document-text" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ t('workflowDetail.contract.registrationNumber') }}
                </label>
                <UInput
                  v-if="props.isEditMode && workflowEditStore.editableWorkflow?.delivery && [Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))"
                  v-model="workflowEditStore.editableWorkflow!.delivery!.licensePlate"
                  color="neutral"
                  highlight
                  placeholder=""
                  size="sm"
                  class="mt-0"
                  :maxlength="10"
                  :ui="{ base: 'text-sm h-8' }"
                />
                <p v-else class="text-sm font-mono font-semibold uppercase text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.delivery?.licensePlate || '-' }}
                </p>
              </div>
              
              <div v-if="(isSapOrder(workflow.purchaseOrders?.[purchaseOrderIndex]) || isNolsOrder(workflow.purchaseOrders?.[purchaseOrderIndex])) && !(workflow?.tenant === Tenant.FI && workflow.purchaseOrders?.[purchaseOrderIndex]?.type === PurchaseOrder.Tyre) && [Permission.VehicleSupplier, Permission.SupplierSuperUser, Permission.TyreSupplier, Permission.ClientAccount, Permission.KeyAccountManager, Permission.Backoffice, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport, Permission.Dealer].some(p => userStore.hasPermission(p))" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-hashtag" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ t('workflowDetail.contract.dealerOrderId') }}
                </label>
                <UInput
                  v-if="props.isEditMode && workflow.purchaseOrders && workflow.purchaseOrders.length > 0 && workflowEditStore.editableWorkflow?.purchaseOrders && [Permission.VehicleSupplier, Permission.SupplierSuperUser, Permission.TyreSupplier, Permission.Dealer, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))"
                  v-model="(workflowEditStore.editableWorkflow!.purchaseOrders![purchaseOrderIndex] ??= {}).supplierInternalOrderNumber"
                  color="neutral"
                  highlight
                  placeholder=""
                  size="sm"
                  class="mt-0"
                  :maxlength="100"
                  :ui="{ base: 'text-sm h-8' }"
                />
                <p v-else class="text-sm font-mono font-semibold text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.purchaseOrders?.[purchaseOrderIndex]?.supplierInternalOrderNumber || '-' }}
                </p>
              </div>
              
              <div v-if="(isCzechiaQuotation(workflow.quotation) || isNolsQuotation(workflow.quotation)) && workflow.purchaseOrders?.[purchaseOrderIndex]?.type !== PurchaseOrder.Tyre" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-clipboard-document-list" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ t('workflowDetail.contract.initialQuotationNumber') }}
                </label>
                <UInput
                  v-if="props.isEditMode && workflowEditStore.editableWorkflow?.quotation && [Permission.ClientAccount, Permission.KeyAccountManager, Permission.Backoffice].some(p => userStore.hasPermission(p))"
                  v-model="workflowEditStore.editableWorkflow!.quotation!.initialQuotationNumber"
                  color="neutral"
                  highlight
                  placeholder=""
                  size="sm"
                  class="mt-0"
                  :maxlength="100"
                  :ui="{ base: 'text-sm h-8 uppercase' }"
                />
                <p v-else class="text-sm font-mono font-semibold uppercase text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.quotation?.initialQuotationNumber || '-' }}
                </p>
              </div>
              
              <div v-if="isVehicleOrderType(workflow.purchaseOrders?.[purchaseOrderIndex]?.type)" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-arrows-right-left" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ workflow?.tenant === Tenant.FI ? t('workflowDetail.contract.registrationDate') : t('workflowDetail.contract.handoverDate') }}
                </label>
                <UPopover v-if="props.isEditMode && !isWorkflowFinal && (workflow?.tenant !== Tenant.CZ || workflow?.delivery?.currentProcessStep === DeliveryStep.Handover) && [Permission.VehicleSupplier, Permission.SupplierSuperUser, Permission.TyreSupplier, Permission.Dealer, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))" v-model:open="isHandoverDatePopoverOpen">
                  <UButton
                    color="neutral"
                    variant="outline"
                    class="w-40 h-8 text-sm justify-start cursor-pointer text-left focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-inverted ring ring-inset ring-inverted"
                    :class="[handoverDate ? '' : 'text-dimmed', showHandoverDateMustBeTodayError ? 'ring-orange-500 border-orange-500' : '']"
                  >
                    <UIcon name="i-lucide-calendar" class="w-4 h-4 mr-0.5"/>
                    {{ handoverDate ? formatDate(handoverDate, 'short', locale) : t('workflowDetail.common.select')  }}
                  </UButton>
                  <template #content>
                    <UCalendar v-model="handoverDate" :locale="locale" :year-controls="false" @update:model-value="isHandoverDatePopoverOpen = false" />
                  </template>
                </UPopover>
                <p v-else class="text-sm font-semibold text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.delivery?.handoverDate ? formatDate(workflowEditStore.editableWorkflow?.delivery?.handoverDate, 'short', locale) : '-' }}
                </p>
                
                <div v-if="showHandoverDateMustBeTodayError" class="mt-1 p-2.5 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
                  <div class="flex items-start gap-2">
                    <UIcon name="i-heroicons-exclamation-circle" class="w-4.5 h-4.5 text-red-500 flex-shrink-0 mt-0.5" />
                    <div class="text-[0.8rem] text-red-700 dark:text-red-300 leading-tight">
                      <p>{{ t('processStatus.registrationDateMustBeTodayMessage') }}</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-if="isVehicleOrderType(workflow.purchaseOrders?.[purchaseOrderIndex]?.type)" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-chart-bar" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ workflow?.tenant === Tenant.FI ? t('workflowDetail.contract.initialMileage') : t('workflowDetail.contract.handoverMileage') }}
                </label>
                <UInput
                  v-if="props.isEditMode && !isWorkflowFinal && workflowEditStore.editableWorkflow?.delivery && (workflow?.tenant !== Tenant.CZ || workflow?.delivery?.currentProcessStep === DeliveryStep.Handover) && [Permission.VehicleSupplier, Permission.SupplierSuperUser, Permission.TyreSupplier, Permission.Dealer, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))"
                  v-model="workflowEditStore.editableWorkflow!.delivery!.handoverMileage"
                  type="number"
                  color="neutral"
                  highlight
                  placeholder=""
                  size="sm"
                  class="mt-0"
                  :ui="{ base: 'text-sm h-8' }"
                />
                <p v-else class="text-sm font-semibold text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.delivery?.handoverMileage ? `${workflowEditStore.editableWorkflow?.delivery?.handoverMileage?.toLocaleString()} km` : '-' }}
                </p>
              </div>
              
              <div v-if="workflow?.tenant === Tenant.CZ" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-building-storefront" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ t('workflowDetail.contract.stockDealer') }}
                </label>
                <p class="text-sm font-semibold text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.vehicle?.isVehicleInStore ? t('workflowDetail.common.yes') : t('workflowDetail.common.no') }}
                </p>
              </div>
              
              <div v-if="(isCzechiaDelivery(workflow.delivery) || isNolsDelivery(workflow.delivery)) && [Permission.VehicleSupplier, Permission.SupplierSuperUser, Permission.TyreSupplier, Permission.ClientAccount, Permission.KeyAccountManager, Permission.Backoffice, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport, Permission.Dealer].some(p => userStore.hasPermission(p))" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-map-pin" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ t('workflowDetail.contract.arrivedAtDealer') }}
                </label>
                <USelect
                  v-if="props.isEditMode && workflowEditStore.editableWorkflow?.delivery && [Permission.VehicleSupplier, Permission.SupplierSuperUser, Permission.TyreSupplier, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport, Permission.Dealer].some(p => userStore.hasPermission(p))"
                  v-model="workflowEditStore.editableWorkflow!.delivery!.arrivedAtDealer"
                  :items="[
                    { label: t('workflowDetail.common.yes'), value: true },
                    { label: t('workflowDetail.common.no'), value: false }
                  ]"
                  color="neutral"
                  highlight
                  size="sm"
                  class="mt-0 w-22"
                  :ui="{ base: 'text-sm h-8' }"
                />
                <p v-else class="text-sm font-semibold text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.delivery?.arrivedAtDealer ? t('workflowDetail.common.yes') : t('workflowDetail.common.no') }}
                </p>
              </div>
              
              <div v-if="isNolsQuotation(workflow?.quotation)" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-user-group" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ t('workflowDetail.contract.poolCar') }}
                </label>
                <p class="text-sm font-semibold text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.quotation?.isPoolCar ? t('workflowDetail.common.yes') : t('workflowDetail.common.no') }}
                </p>
              </div>
              
              <div v-if="props.isPublicView || [Permission.CustomerCare, Permission.Driver, Permission.HR, Permission.FleetManager, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport, Permission.VehicleSupplier, Permission.SupplierSuperUser].some(p => userStore.hasPermission(p))" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-arrow-path" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ t('workflowDetail.contract.replacedCarRegNumber') }}
                </label>
                <UInput
                  v-if="props.isEditMode && workflowEditStore.editableWorkflow && [Permission.CustomerCare, Permission.ClientAccount, Permission.Backoffice, Permission.FleetManager, Permission.Driver, Permission.HR].some(p => userStore.hasPermission(p))"
                  v-model="(workflowEditStore.editableWorkflow!.replacedCar ??= {}).licensePlate"
                  color="neutral"
                  highlight
                  placeholder=""
                  size="sm"
                  :maxlength="9"
                  class="mt-0"
                  :ui="{ base: 'text-sm uppercase h-8' }"
                />
                <p v-else class="text-sm font-mono font-semibold uppercase text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.replacedCar?.licensePlate || '-' }}
                </p>
              </div>
              
              <div v-if="workflow?.tenant === Tenant.CZ && (props.isPublicView || [Permission.CustomerCare, Permission.Driver, Permission.HR, Permission.FleetManager, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport].some(p => userStore.hasPermission(p)))" class="p-1.5 rounded-xl bg-gray-50/80 dark:bg-gray-800/40 border border-gray-100 dark:border-gray-700/50">
                <label class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-md flex items-center justify-center">
                    <UIcon name="i-heroicons-clock" class="w-3.5 h-3.5 text-primary-600 dark:text-primary-400" />
                  </span>
                  {{ t('workflowDetail.contract.replacedCarContractEnd') }}
                </label>
                <p class="text-sm font-semibold text-gray-900 dark:text-white mt-0 h-8 flex items-center">
                  {{ workflowEditStore.editableWorkflow?.replacedCarContractEndDate ? formatDate(workflowEditStore.editableWorkflow.replacedCarContractEndDate, 'date', locale) : '-' }}
                </p>
              </div>
            </div>
          </UCard>
          </div>
          
          <div v-if="workflow?.purchaseOrders?.[purchaseOrderIndex]?.type === PurchaseOrder.Tyre" class="relative pt-[12px]">
            <div class="absolute top-0 left-3 z-[1] flex items-center gap-1.5 px-2.5 py-1 bg-orange-50 dark:bg-orange-900/50 ring-1 ring-orange-400 dark:ring-orange-500 rounded-full shadow-sm">
              <UIcon name="i-mdi-tire" class="w-3.5 h-3.5 text-orange-600 dark:text-orange-400"/>
              <span class="text-xs font-semibold text-orange-700 dark:text-orange-300 whitespace-nowrap">{{ t('workflowDetail.overview.tyreSectionTitle') }}</span>
            </div>
            <UCard class="overflow-hidden shadow-md border-0 border-l-3 border-l-orange-400 dark:border-l-orange-500 bg-(--ui-bg)/90 backdrop-blur-sm" :ui="{ root: 'divide-none shadow-xs', body: 'pt-5 px-2 pb-2 sm:pt-5 sm:px-2 sm:pb-2' }">
            <div class="flex flex-col md:flex-row gap-2 mb-2">
              <div class="md:flex-1 bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 rounded-lg p-2.5">
                <h3 class="text-sm font-medium text-blue-700 dark:text-blue-300 mb-2 text-center">{{ t('workflowDetail.tyreSpec.listPrice') }}</h3>
                <div class="flex justify-center gap-14">
                  <div class="text-center">
                    <div class="text-xs font-medium text-blue-600 dark:text-blue-400 mb-0">{{ t('workflowDetail.tyreSpec.perPiece') }}</div>
                    <div class="text-lg font-semibold text-blue-900 dark:text-blue-100">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.listPrice != null ? formatPriceWithCurrency(workflow?.purchaseOrders?.[purchaseOrderIndex]?.listPrice, workflow?.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                  </div>
                  <div class="text-center">
                    <div class="text-xs font-medium text-blue-600 dark:text-blue-400 mb-0">{{ t('workflowDetail.tyreSpec.total') }}</div>
                    <div class="text-lg font-semibold text-blue-900 dark:text-blue-100">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.listPrice != null && workflow?.purchaseOrders?.[purchaseOrderIndex]?.quantity != null ? formatPriceWithCurrency(workflow?.purchaseOrders?.[purchaseOrderIndex]?.listPrice * workflow?.purchaseOrders?.[purchaseOrderIndex]?.quantity, workflow?.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                  </div>
                </div>
              </div>
              
              <div class="md:flex-1 bg-gradient-to-br from-rose-50 to-rose-100 dark:from-rose-900/30 dark:to-rose-800/30 rounded-lg p-2.5">
                <h3 class="text-sm font-medium text-rose-700 dark:text-rose-300 mb-2 text-center">{{ t('workflowDetail.tyreSpec.discount') }}</h3>
                <div class="flex justify-center gap-14">
                  <div class="text-center">
                    <div class="text-xs font-medium text-rose-600 dark:text-rose-400 mb-0">%</div>
                    <div class="text-lg font-semibold text-rose-900 dark:text-rose-100">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.listPrice && workflow?.purchaseOrders?.[purchaseOrderIndex]?.discount ? `-${Math.round((Math.abs(workflow?.purchaseOrders?.[purchaseOrderIndex]?.discount) / workflow?.purchaseOrders?.[purchaseOrderIndex]?.listPrice) * 100)}%` : '-' }}</div>
                  </div>
                  <div class="text-center">
                    <div class="text-xs font-medium text-rose-600 dark:text-rose-400 mb-0">{{ t('workflowDetail.tyreSpec.perPiece') }}</div>
                    <div class="text-lg font-semibold text-rose-900 dark:text-rose-100">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.discount != null && workflow?.purchaseOrders?.[purchaseOrderIndex]?.discount !== 0 ? `-${formatPriceWithCurrency(Math.abs(workflow?.purchaseOrders?.[purchaseOrderIndex]?.discount), workflow?.quotation?.financials?.transactionCurrency, locale, 2)}` : '-' }}</div>
                  </div>
                </div>
              </div>
              
              <div class="md:flex-1 bg-gradient-to-br from-emerald-50 to-emerald-100 dark:from-emerald-900/30 dark:to-emerald-800/30 rounded-lg p-2.5">
                <h3 class="text-sm font-medium text-emerald-700 dark:text-emerald-300 mb-2 text-center">{{ t('workflowDetail.tyreSpec.netPrice') }}</h3>
                <div class="flex justify-center gap-14">
                  <div class="text-center">
                    <div class="text-xs font-medium text-emerald-600 dark:text-emerald-400 mb-0">{{ t('workflowDetail.tyreSpec.perPiece') }}</div>
                    <div class="text-lg font-semibold text-emerald-900 dark:text-emerald-100">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.netPrice != null ? formatPriceWithCurrency(workflow?.purchaseOrders?.[purchaseOrderIndex]?.netPrice, workflow?.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                  </div>
                  <div class="text-center">
                    <div class="text-xs font-medium text-emerald-600 dark:text-emerald-400 mb-0">{{ t('workflowDetail.tyreSpec.total') }}</div>
                    <div class="text-lg font-semibold text-emerald-900 dark:text-emerald-100">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.netPrice != null && workflow?.purchaseOrders?.[purchaseOrderIndex]?.quantity != null ? formatPriceWithCurrency(workflow?.purchaseOrders?.[purchaseOrderIndex]?.netPrice * workflow?.purchaseOrders?.[purchaseOrderIndex]?.quantity, workflow?.quotation?.financials?.transactionCurrency, locale, 2) : '-' }}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="flex flex-wrap gap-2 mb-2">
              <div class="flex-1 min-w-[200px] group px-2.5 py-2 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900/30 dark:to-gray-800/30 rounded-lg">
                <div class="flex items-center gap-2 mb-1">
                  <UIcon name="i-mdi-tire" class="w-4 h-4 text-gray-600 dark:text-gray-400"/>
                  <span class="text-xs font-medium text-gray-600 dark:text-gray-400">{{ t('workflowDetail.tyreSpec.title') }}</span>
                </div>
                <p class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.tyreName ?? '-' }}</p>
              </div>
              
              <div class="flex-1 min-w-[140px] group px-2.5 py-2 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900/30 dark:to-gray-800/30 rounded-lg">
                <div class="flex items-center gap-2 mb-1">
                  <UIcon name="i-mdi-diameter-outline" class="w-4 h-4 text-gray-600 dark:text-gray-400"/>
                  <span class="text-xs font-medium text-gray-600 dark:text-gray-400">{{ t('workflowDetail.tyreSpec.dimensions') }}</span>
                </div>
                <div class="flex items-baseline gap-0.5">
                  <template v-if="workflow?.purchaseOrders?.[purchaseOrderIndex]?.tyreWidth != null && workflow?.purchaseOrders?.[purchaseOrderIndex]?.tyreProfile != null && workflow?.purchaseOrders?.[purchaseOrderIndex]?.rimDiameter != null">
                    <span class="text-base font-bold text-gray-900 dark:text-gray-100 font-mono tracking-wide">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.tyreWidth }}</span>
                    <span class="text-base font-bold text-gray-400 dark:text-gray-500 font-mono tracking-wide">/</span>
                    <span class="text-base font-bold text-gray-900 dark:text-gray-100 font-mono tracking-wide">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.tyreProfile }}</span>
                    <span class="text-base font-bold text-gray-400 dark:text-gray-500 font-mono tracking-wide ml-1">R</span>
                    <span class="text-base font-bold text-gray-900 dark:text-gray-100 font-mono tracking-wide">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.rimDiameter }}</span>
                  </template>
                  <span v-else class="text-sm font-semibold text-gray-900 dark:text-gray-100">-</span>
                </div>
              </div>
              
              <div class="flex-1 min-w-[120px] group px-2.5 py-2 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900/30 dark:to-gray-800/30 rounded-lg">
                <div class="flex items-center gap-2 mb-1">
                  <UIcon :name="workflow?.purchaseOrders?.[purchaseOrderIndex]?.tyresType === 'SU' ? 'i-mdi-weather-sunny' : workflow?.purchaseOrders?.[purchaseOrderIndex]?.tyresType === 'AS' ? 'i-mdi-weather-partly-cloudy' : 'i-mdi-snowflake'" class="w-4 h-4 text-gray-600 dark:text-gray-400"/>
                  <span class="text-xs font-medium text-gray-600 dark:text-gray-400">{{ t('workflowDetail.tyreSpec.type') }}</span>
                </div>
                <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ { 'SU': t('workflowDetail.tyreSpec.typeSummer'), 'W': t('workflowDetail.tyreSpec.typeWinter'), 'WN': t('workflowDetail.tyreSpec.typeWinter'), 'WS': t('workflowDetail.tyreSpec.typeWinterStudded'), 'AS': t('workflowDetail.tyreSpec.typeAllSeason') }[workflow?.purchaseOrders?.[purchaseOrderIndex]?.tyresType] ?? workflow?.purchaseOrders?.[purchaseOrderIndex]?.tyresType ?? '-' }}</span>
              </div>
            </div>
            
            <div class="grid grid-cols-2 md:grid-cols-4 gap-2.5">
              <div class="group p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-mdi-package-variant" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.tyreSpec.quantity') }}
                </p>
                <div class="pl-1">
                  <span class="font-semibold text-sm text-gray-900 dark:text-gray-100">{{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.quantity != null ? `${workflow?.purchaseOrders?.[purchaseOrderIndex]?.quantity} ${t('workflowDetail.tyreSpec.pcs')}` : '-' }}</span>
                </div>
              </div>
              
              <div class="group p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-mdi-speedometer" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.tyreSpec.speedIndex') }}
                </p>
                <div class="pl-1">
                  <span class="font-semibold text-sm text-gray-900 dark:text-gray-100">-</span>
                </div>
              </div>
              
              <div class="group p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-mdi-weight" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.tyreSpec.loadIndex') }}
                </p>
                <div class="pl-1">
                  <span class="font-semibold text-sm text-gray-900 dark:text-gray-100">-</span>
                </div>
              </div>
              
              <div class="group p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-mdi-access-point" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.tyreSpec.rimSensor') }}
                </p>
                <div class="pl-1">
                  <span v-if="workflow?.purchaseOrders?.[purchaseOrderIndex]?.rimSensor" class="inline-flex items-center gap-1 text-sm font-semibold text-emerald-600 dark:text-emerald-400">
                    <UIcon name="i-heroicons-check-circle" class="w-4 h-4"/>
                    {{ workflow?.purchaseOrders?.[purchaseOrderIndex]?.rimSensor }}
                  </span>
                  <span v-else class="inline-flex items-center gap-1 text-sm font-semibold text-gray-400 dark:text-gray-500">
                    <UIcon name="i-heroicons-x-circle" class="w-4 h-4"/>
                    {{ t('workflowDetail.common.no') }}
                  </span>
                </div>
              </div>
            </div>
          </UCard>
          </div>
          
          <div class="relative pt-[12px]">
            <div class="absolute top-0 left-3 z-[1] flex items-center gap-1.5 px-2.5 py-1 bg-indigo-50 dark:bg-indigo-900/50 ring-1 ring-indigo-400 dark:ring-indigo-500 rounded-full shadow-sm">
              <UIcon name="i-mdi-car" class="w-3.5 h-3.5 text-indigo-600 dark:text-indigo-400"/>
              <span class="text-xs font-semibold text-indigo-700 dark:text-indigo-300 whitespace-nowrap">{{ t('workflowDetail.overview.vehicleSectionTitle') }}</span>
            </div>
            <UCard class="overflow-hidden shadow-md border-0 border-l-3 border-l-indigo-400 dark:border-l-indigo-500 bg-(--ui-bg)/90 backdrop-blur-sm" :ui="{ root: 'divide-none shadow-xs', body: 'pt-5 px-2 pb-2 sm:pt-5 sm:px-2 sm:pb-2' }">
            <div class="grid grid-cols-2 md:grid-cols-6 lg:grid-cols-12 gap-2.5">
              <div class="group col-span-2 md:col-span-3 lg:col-span-3 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-heroicons-building-office-2" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.make') }}
                </p>
                <div class="pl-1 flex items-center justify-between gap-2">
                  <div class="min-w-0 flex-1">
                    <p class="font-semibold text-sm text-gray-900 dark:text-gray-100 truncate" :title="workflow?.vehicle?.manufacturer || '-'">{{ workflow?.vehicle?.manufacturer || '-' }}</p>
                    <p class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider">{{ t('workflowDetail.vehicle.makeName') }}</p>
                  </div>
                  <div class="text-right">
                    <p class="font-mono text-sm text-gray-700 dark:text-gray-200">{{ workflow?.vehicle?.manufacturerCode || '-' }}</p>
                    <p class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider">{{ t('workflowDetail.vehicle.code') }}</p>
                  </div>
                </div>
              </div>
              
              <div class="group col-span-2 md:col-span-3 lg:col-span-3 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-heroicons-squares-2x2" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.model') }}
                </p>
                <div class="pl-1 flex items-center justify-between gap-2">
                  <div class="min-w-0 flex-1">
                    <p class="font-semibold text-sm leading-tight text-gray-900 dark:text-gray-100 truncate" :title="`${workflow?.vehicle?.model || '-'} ${workflow?.vehicle?.trim || ''}`">{{ workflow?.vehicle?.model || '-' }} {{ workflow?.vehicle?.trim }}</p>
                    <p class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider">{{ t('workflowDetail.vehicle.modelName') }}</p>
                  </div>
                  <div v-if="workflow?.tenant === Tenant.CZ" class="text-right">
                    <p class="font-mono text-sm text-gray-700 dark:text-gray-200">{{ workflow?.vehicle?.modelCode || '-' }}</p>
                    <p class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider">{{ t('workflowDetail.vehicle.code') }}</p>
                  </div>
                </div>
              </div>
              
              <div class="group col-span-2 md:col-span-3 lg:col-span-3 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-heroicons-paint-brush" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.exterior') }}
                </p>
                <div class="pl-1 flex items-center gap-2">
                  <div class="w-4 h-4 rounded-full bg-conic/decreasing from-violet-700 via-lime-300 to-violet-700 border border-gray-300 dark:border-gray-600 shadow-sm flex-shrink-0"></div>
                  <div class="min-w-0 flex-1">
                    <p class="font-semibold text-sm text-gray-900 dark:text-gray-100 capitalize truncate" :title="workflow?.vehicle?.vehicleColor || '-'">{{ workflow?.vehicle?.vehicleColor || '-' }}</p>
                    <p class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider">{{ t('workflowDetail.vehicle.color') }}</p>
                  </div>
                </div>
              </div>
              
              <div class="group col-span-2 md:col-span-3 lg:col-span-3 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-heroicons-swatch" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.upholstery') }}
                </p>
                <div class="pl-1 flex items-center justify-between gap-2">
                  <div class="min-w-0 flex-1">
                    <p class="font-semibold text-sm text-gray-900 dark:text-gray-100 capitalize truncate" :title="workflow?.vehicle?.upholsteryColor || '-'">{{ workflow?.vehicle?.upholsteryColor || '-' }}</p>
                    <p class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider">{{ t('workflowDetail.vehicle.color') }}</p>
                  </div>
                  <div class="text-right min-w-0 flex-1">
                    <p class="font-semibold text-sm text-gray-900 dark:text-gray-100 capitalize truncate" :title="workflow?.vehicle?.upholsteryMaterial || '-'">{{ workflow?.vehicle?.upholsteryMaterial || '-' }}</p>
                    <p class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wider">{{ t('workflowDetail.vehicle.material') }}</p>
                  </div>
                </div>
              </div>
              
              <div class="group col-span-1 md:col-span-2 lg:col-span-2 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-heroicons-bolt" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.enginePower') }}
                </p>
                <div class="pl-1">
                  <span class="font-semibold text-sm text-gray-900 dark:text-gray-100">{{ workflow?.vehicle?.powerKW || '-' }} <span class="font-normal text-gray-500 dark:text-gray-400">kW</span></span>
                </div>
              </div>
              
              <div class="group col-span-1 md:col-span-2 lg:col-span-2 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-heroicons-clipboard-document-check" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.homologation') }}
                </p>
                <div class="pl-1">
                  <span class="font-semibold text-sm text-gray-900 dark:text-gray-100">{{ workflow?.vehicle?.homologation || '-' }}</span>
                </div>
              </div>
              
              <div class="group col-span-1 md:col-span-2 lg:col-span-2 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-mdi-tire" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.wheelCount') }}
                </p>
                <div class="pl-1">
                  <span class="font-semibold text-sm text-gray-900 dark:text-gray-100">{{ workflow?.vehicle?.numberOfTyres || '-' }}</span>
                </div>
              </div>
              
              <div class="group col-span-1 md:col-span-2 lg:col-span-2 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-mdi-car-seat" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.seats') }}
                </p>
                <div class="pl-1">
                  <span class="font-semibold text-sm text-gray-900 dark:text-gray-100">{{ workflow?.vehicle?.numberOfSeats || '-' }}</span>
                </div>
              </div>
              
              <div class="group col-span-1 md:col-span-2 lg:col-span-2 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-heroicons-cloud" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.co2Emissions') }}
                </p>
                <div class="pl-1 flex items-baseline gap-1">
                  <UInput
                    v-if="props.isEditMode && workflowEditStore.editableWorkflow?.delivery && [Permission.DeliveryManager, Permission.DeliverySpecialist].some(p => userStore.hasPermission(p))"
                    v-model="workflowEditStore.editableWorkflow!.delivery!.cO2"
                    type="number"
                    color="neutral"
                    highlight
                    placeholder=""
                    size="sm"
                    class="mt-0 w-24"
                    :ui="{ base: 'text-sm h-8' }"
                  />
                  <span v-else class="font-semibold text-sm text-gray-900 dark:text-gray-100 h-8 flex items-center">{{ workflow?.delivery?.cO2 ?? '-' }}</span>
                  <span class="text-xs text-gray-500 dark:text-gray-400">g/km</span>
                </div>
              </div>
              
              <div class="group col-span-1 md:col-span-2 lg:col-span-2 p-1.5 rounded-xl bg-(--ui-bg-muted) border border-gray-100 dark:border-gray-600/50">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 flex items-center gap-1.5">
                  <span class="p-1 bg-slate-100 dark:bg-slate-700/40 rounded-lg">
                    <UIcon name="i-heroicons-tag" class="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
                  </span>
                  {{ t('workflowDetail.vehicle.category') }}
                </p>
                <div class="pl-1">
                  <span class="font-semibold text-sm text-gray-900 dark:text-gray-100">{{ workflow?.vehicle?.category || '-' }}</span>
                </div>
              </div>
            </div>
          </UCard>
          </div>
        </div>
        
        <div class="order-1 xl:order-none xl:col-span-4 xl:col-start-9 xl:row-start-1">
          <UCard v-if="workflow" class="shadow-md border-0 bg-(--ui-bg)/90 backdrop-blur-sm" :ui="{ root: 'divide-none shadow-xs', header: 'p-2 sm:px-2 sm:py-1', body: 'p-1.5 sm:p-1.5' }">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-1.5">
              <!--
              <div v-if="workflow?.tenant === Tenant.FI" class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                <div class="flex items-center gap-1.5 mb-1">
                  <UIcon name="i-heroicons-cube" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                  <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.contract.financialProduct') }}</span>
                </div>
                <p class="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate" :title="getSapLocalizedText(workflow?.quotation?.financialProduct, locale)">{{ getSapLocalizedText(workflow?.quotation?.financialProduct, locale) }}</p>
              </div>
              <div v-if="workflow?.tenant === Tenant.FI" class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                <div class="flex items-center gap-1.5 mb-1">
                  <UIcon name="i-heroicons-cube" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                  <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.contract.commercialProduct') }}</span>
                </div>
                <p class="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate" :title="getSapLocalizedText(workflow?.quotation?.commercialProduct, locale)">{{ getSapLocalizedText(workflow?.quotation?.commercialProduct, locale) }}</p>
              </div>
              -->
              <div class="md:col-span-2 flex flex-col items-center py-2 rounded-lg bg-gradient-to-br from-blue-50 to-blue-100/50 dark:from-blue-900/20 dark:to-blue-800/10 ring-1 ring-blue-200/60 dark:ring-blue-700/35">
                <span class="text-[0.65rem] font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wider">{{ t('workflowDetail.contract.externalReference') }}</span>
                <span class="mt-0.5 text-base font-mono font-bold text-gray-900 dark:text-gray-100 tracking-tight">{{ workflow.externalReference }}</span>
              </div>
              <div class="md:col-span-2 grid grid-cols-2 gap-1.5">
                <div class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                  <div class="flex items-center gap-1.5 mb-1">
                    <UIcon name="i-heroicons-calendar-days" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                    <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.contract.createdDate') }}</span>
                  </div>
                  <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ contractCreatedDate ? formatDate(contractCreatedDate, 'datetime', locale) : '-' }}</span>
                </div>
                <div v-if="!isNolsQuotation(workflow.quotation) && (props.viewQuotationData || isQuotationPhase)" class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                  <div class="flex items-center gap-1.5 mb-1">
                    <UIcon name="i-heroicons-clock" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                    <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.contract.quotationValidTo') }}</span>
                  </div>
                  <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ workflow.quotation?.validTo ? formatDate(workflow.quotation.validTo, 'short', locale) : '-' }}</span>
                </div>
                <div v-if="isNolsDelivery(workflow.delivery)" class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                  <div class="flex items-center gap-1.5 mb-1">
                    <UIcon name="i-heroicons-envelope" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                    <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.contract.handoverRequestSend') }}</span>
                  </div>
                  <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ workflow.delivery?.handoverRequestedDate ? formatDate(workflow.delivery.handoverRequestedDate, 'short', locale) : '-' }}</span>
                </div>
              </div>
              <div v-if="showBenefitInKind" class="md:col-span-2 grid grid-cols-2 gap-1.5">
                <div v-if="workflow?.quotation?.benefitInKind?.fullBenefitValue != null" class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                  <div class="flex items-center gap-1.5 mb-1">
                    <UIcon name="i-lucide-banknote" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                    <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.driver.fullBenefitValue') }}</span>
                  </div>
                  <span class="text-sm font-semibold tabular-nums text-gray-900 dark:text-gray-100">{{ formatPriceWithCurrency(workflow.quotation.benefitInKind.fullBenefitValue, 'EUR', locale, 2) }}</span>
                </div>
                <div v-if="workflow?.quotation?.benefitInKind?.limitedBenefitValue != null" class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                  <div class="flex items-center gap-1.5 mb-1">
                    <UIcon name="i-lucide-coins" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                    <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.driver.limitedBenefitValue') }}</span>
                  </div>
                  <span class="text-sm font-semibold tabular-nums text-gray-900 dark:text-gray-100">{{ formatPriceWithCurrency(workflow.quotation.benefitInKind.limitedBenefitValue, 'EUR', locale, 2) }}</span>
                </div>
              </div>
              <div v-if="isNolsDelivery(workflow.delivery)" class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                <div class="flex items-center gap-1.5 mb-1">
                  <UIcon name="i-heroicons-document-text" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                  <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.contract.requestForRegistration') }}</span>
                </div>
                <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ workflow.delivery?.plateRequestedDate ? formatDate(workflow.delivery.plateRequestedDate, 'short', locale) : '-' }}</span>
              </div>
              <div v-if="isNolsDelivery(workflow.delivery)" class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                <div class="flex items-center gap-1.5 mb-1">
                  <UIcon name="i-heroicons-identification" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                  <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.contract.firstRegistrationDate') }}</span>
                </div>
                <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ workflow.delivery?.registrationDate ? formatDate(workflow.delivery.registrationDate, 'short', locale) : '-' }}</span>
              </div>
              <!--
              <div v-if="workflow?.tenant === Tenant.CZ" class="px-1.5 py-1.5 bg-(--ui-bg-muted) rounded-md border border-gray-100 dark:border-gray-600/50">
                <div class="flex items-center gap-1.5 mb-1">
                  <UIcon name="i-heroicons-cube" class="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                  <span class="text-xs font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wide">{{ t('workflowDetail.contract.product') }}</span>
                </div>
                <span class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ '-' }}</span>
              </div>
              -->
            </div>
          </UCard>
        </div>

        <div class="order-3 xl:order-none xl:col-span-4 xl:col-start-9 xl:row-start-2 space-y-3">
          <div class="relative pt-[12px]">
            <div class="absolute top-0 left-3 z-[1] flex items-center gap-1.5 px-2.5 py-1 bg-indigo-50 dark:bg-indigo-900/50 ring-1 ring-indigo-400 dark:ring-indigo-500 rounded-full shadow-sm">
              <UIcon name="i-lucide-key-round" class="w-3.5 h-3.5 text-indigo-600 dark:text-indigo-400"/>
              <span class="text-xs font-semibold text-indigo-700 dark:text-indigo-300 whitespace-nowrap">{{ t('workflowDetail.driver.title') }}</span>
            </div>
            <div v-if="props.isEditMode && workflow?.tenant !== Tenant.CZ && workflowEditStore.editableWorkflow && (props.isPublicView || [Permission.CustomerCare, Permission.ClientAccount, Permission.Backoffice, Permission.FleetManager, Permission.Driver, Permission.HR].some(p => userStore.hasPermission(p)))" class="absolute -top-0.5 right-3 z-10 flex items-center gap-1">
              <USelect
                v-model="workflowEditStore.editableWorkflow!.driverId"
                :items="(drivers ?? []).map(driver => ({
                  label: `${driver.name}`,
                  value: driver.id
                }))"
                color="neutral"
                highlight
                :placeholder="t('workflowDetail.common.select')"
                size="sm"
                class="w-48"
                :ui="{ base: 'text-xs h-7' }"
              />
              <button
                v-if="workflowEditStore.editableWorkflow?.driverId"
                @click="workflowEditStore.editableWorkflow!.driverId = null"
                class="p-1 rounded-full bg-red-50 dark:bg-red-900/30 ring-1 ring-red-300 dark:ring-red-700 transition-colors hover:bg-red-100 dark:hover:bg-red-900/50 shadow-sm"
                type="button"
              >
                <UIcon name="i-heroicons-x-mark" class="w-3.5 h-3.5 text-red-500 dark:text-red-400" />
              </button>
            </div>
            <UCard class="shadow-md border-0 border-l-3 border-l-indigo-400 dark:border-l-indigo-500 bg-(--ui-bg)/90 backdrop-blur-sm" :ui="{ root: 'divide-none shadow-xs', body: 'pt-5 px-1.5 pb-1.5 sm:pt-5 sm:px-1.5 sm:pb-1.5' }">
            <div class="px-1.5">
              <div v-if="props.driverLoading" class="flex items-center justify-center py-3">
                <UIcon name="i-heroicons-arrow-path" class="w-5 h-5 animate-spin text-indigo-400"/>
              </div>
              <div v-else-if="props.driverError" class="flex items-center gap-2 py-3 px-2 bg-red-50 dark:bg-red-900/20 rounded-md">
                <UIcon name="i-heroicons-exclamation-triangle" class="w-4 h-4 text-red-500"/>
                <span class="text-xs text-red-600 dark:text-red-400">{{ t('workflowDetail.driver.serviceUnavailable') }}</span>
              </div>
              <div v-else class="grid grid-cols-2 gap-1.5">
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-user" class="w-4 h-4 text-indigo-600 dark:text-indigo-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.driver.name') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">
                    {{ [props.driver?.firstName, props.driver?.lastName].filter(Boolean).join(' ') || '-' }}
                  </p>
                </div>
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-hashtag" class="w-4 h-4 text-indigo-600 dark:text-indigo-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.driver.id') }}</p>
                  </div>
                  <p class="text-sm font-mono font-semibold text-gray-900 dark:text-white">
                    {{ props.driver?.businessPartnerId || '-' }}
                  </p>
                </div>
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-phone" class="w-4 h-4 text-indigo-600 dark:text-indigo-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.driver.phone') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">
                    {{ props.driver?.phone || '-' }}
                  </p>
                </div>
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-envelope" class="w-4 h-4 text-indigo-600 dark:text-indigo-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.driver.email') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">
                    {{ props.driver?.email || '-' }}
                  </p>
                </div>
                <div v-if="workflow?.tenant === Tenant.FI">
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-identification" class="w-4 h-4 text-indigo-600 dark:text-indigo-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.driver.staffId') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">
                    {{ props.driver?.staffId || '-' }}
                  </p>
                </div>
                <div v-if="workflow?.tenant === Tenant.FI && props.driver">
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-lucide-award" class="w-4 h-4 text-indigo-600 dark:text-indigo-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.driver.carBenefitLevel') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">
                    {{ driverBenefitLevelLabel }}
                  </p>
                </div>
              </div>
            </div>
          </UCard>
          </div>
          
          <div v-if="workflow?.tenant === Tenant.FI" class="relative pt-[12px]">
            <div class="absolute top-0 left-3 z-[1] flex items-center gap-1.5 px-2.5 py-1 bg-amber-50 dark:bg-amber-900/50 ring-1 ring-amber-400 dark:ring-amber-500 rounded-full shadow-sm">
              <UIcon name="i-heroicons-phone" class="w-3.5 h-3.5 text-amber-600 dark:text-amber-400"/>
              <span class="text-xs font-semibold text-amber-700 dark:text-amber-300 whitespace-nowrap">{{ t('workflowDetail.contactForVehicle.title') }}</span>
            </div>
            <UCard class="shadow-md border-0 border-l-3 border-l-amber-400 dark:border-l-amber-500 bg-(--ui-bg)/90 backdrop-blur-sm" :ui="{ root: 'divide-none shadow-xs', body: 'pt-5 px-1.5 pb-1.5 sm:pt-5 sm:px-1.5 sm:pb-1.5' }">
            <div class="px-1.5">
              <div v-if="props.contactPersonLoading" class="flex items-center justify-center py-3">
                <UIcon name="i-heroicons-arrow-path" class="w-5 h-5 animate-spin text-amber-400"/>
              </div>
              <div v-else-if="props.contactPersonError" class="flex items-center gap-2 py-3 px-2 bg-red-50 dark:bg-red-900/20 rounded-md">
                <UIcon name="i-heroicons-exclamation-triangle" class="w-4 h-4 text-red-500"/>
                <span class="text-xs text-red-600 dark:text-red-400">{{ t('workflowDetail.contactForVehicle.serviceUnavailable') }}</span>
              </div>
              <div v-else class="grid grid-cols-2 gap-1.5">
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-user" class="w-4 h-4 text-amber-600 dark:text-amber-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.contactForVehicle.name') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ props.contactPerson?.fullName || '-' }}</p>
                </div>
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-hashtag" class="w-4 h-4 text-amber-600 dark:text-amber-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.contactForVehicle.id') }}</p>
                  </div>
                  <p class="text-sm font-mono font-semibold text-gray-900 dark:text-white">{{ props.contactPerson?.id || '-' }}</p>
                </div>
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-phone" class="w-4 h-4 text-amber-600 dark:text-amber-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.contactForVehicle.phone') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ props.contactPerson?.phone || '-' }}</p>
                </div>
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-envelope" class="w-4 h-4 text-amber-600 dark:text-amber-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.contactForVehicle.email') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ props.contactPerson?.email || '-' }}</p>
                </div>
              </div>
            </div>
          </UCard>
          </div>
          
          <div v-if="workflow" class="relative pt-[12px]">
            <div class="absolute top-0 left-3 z-[1] flex items-center gap-1.5 px-2.5 py-1 bg-purple-50 dark:bg-purple-900/50 ring-1 ring-purple-400 dark:ring-purple-500 rounded-full shadow-sm">
              <UIcon name="i-heroicons-user" class="w-3.5 h-3.5 text-purple-600 dark:text-purple-400"/>
              <span class="text-xs font-semibold text-purple-700 dark:text-purple-300 whitespace-nowrap">{{ t('workflowDetail.client.title') }}</span>
            </div>
            <UCard class="shadow-md border-0 border-l-3 border-l-purple-400 dark:border-l-purple-500 bg-(--ui-bg)/90 backdrop-blur-sm" :ui="{ root: 'divide-none shadow-xs', body: 'pt-5 px-1.5 pb-1.5 sm:pt-5 sm:px-1.5 sm:pb-1.5' }">
            <div class="px-1.5">
              <div class="grid grid-cols-2 gap-1.5">
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-identification" class="w-4 h-4 text-purple-600 dark:text-purple-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.client.name') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ workflow.client.name }}</p>
                </div>
                <div v-if="props.isPublicView || [Permission.CustomerCare, Permission.Driver, Permission.HR, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))">
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-hashtag" class="w-4 h-4 text-purple-600 dark:text-purple-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.client.id') }}</p>
                  </div>
                  <p class="text-sm font-mono font-semibold text-gray-900 dark:text-white">{{ workflow.client.id }}</p>
                </div>
                <div v-if="(props.isPublicView || [Permission.CustomerCare, Permission.Driver, Permission.HR, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))) && workflow?.tenant !== Tenant.FI">
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-document-text" class="w-4 h-4 text-purple-600 dark:text-purple-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.client.contractNumber') }}</p>
                  </div>
                  <p class="text-sm font-mono font-semibold text-gray-900 dark:text-white">{{ workflow.contractNumber || '-' }}</p>
                </div>
                <div v-if="props.isPublicView || [Permission.CustomerCare, Permission.Driver, Permission.HR, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))" class="col-span-2">
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-building-office" class="w-4 h-4 text-purple-600 dark:text-purple-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ workflow?.tenant === Tenant.CZ ? t('workflowDetail.client.costCentreNumber') : t('workflowDetail.client.costCentre') }}</p>
                  </div>
                  <p v-if="workflow?.tenant === Tenant.CZ" class="text-sm font-semibold text-gray-900 dark:text-white">{{ workflow?.quotation?.profitCenter ?? '-' }}</p>
                  <div v-else-if="props.costCenterLoading" class="flex items-center py-0.5">
                    <UIcon name="i-heroicons-arrow-path" class="w-4 h-4 animate-spin text-purple-500"/>
                  </div>
                  <div v-else-if="props.costCenterError && !(props.costCenter?.organizationName?.trim() || props.costCenter?.id || workflow?.costCenterId)" class="flex items-center gap-2">
                    <UIcon name="i-heroicons-exclamation-triangle" class="w-4 h-4 text-red-500"/>
                    <p class="text-xs text-red-600 dark:text-red-400">{{ t('workflowDetail.client.serviceUnavailable') }}</p>
                  </div>
                  <p v-else class="text-sm font-semibold text-gray-900 dark:text-white">{{ props.costCenter?.organizationName?.trim() || props.costCenter?.id || workflow?.costCenterId || '-' }}</p>
                </div>
              </div>
            </div>
          </UCard>
          </div>
          
          <div v-if="workflow && ((workflow.purchaseOrders && workflow.purchaseOrders?.[purchaseOrderIndex]?.supplier) || (workflow.quotation && workflow.quotation.dealer))" class="relative pt-[12px]">
            <div class="absolute top-0 left-3 z-[1] flex items-center gap-1.5 px-2.5 py-1 bg-green-50 dark:bg-green-900/50 ring-1 ring-green-400 dark:ring-green-500 rounded-full shadow-sm">
              <UIcon name="i-heroicons-building-storefront" class="w-3.5 h-3.5 text-green-600 dark:text-green-400"/>
              <span class="text-xs font-semibold text-green-700 dark:text-green-300 whitespace-nowrap">{{ t('workflowDetail.supplier.title') }}</span>
            </div>
            <!--
            <div class="absolute top-0 right-3 z-[1]">
              <UBadge size="md" color="neutral" variant="soft" class="font-semibold rounded-full shadow-sm">
                <UIcon name="i-lucide-circle-check-big" class="w-3.5 h-3.5 text-green-600 dark:text-green-400 mr-1" />
                {{ t('workflowDetail.supplier.usingEOrders') }}
              </UBadge>
              <UBadge size="md" color="neutral" variant="soft" class="font-semibold rounded-full shadow-sm">
                <UIcon name="i-lucide-circle-x" class="w-3.5 h-3.5 text-red-600 dark:text-red-400 mr-1" />
                {{ t('workflowDetail.supplier.notUsingEOrders') }}
              </UBadge>
            </div>
            -->
            <UCard class="shadow-md border-0 border-l-3 border-l-green-400 dark:border-l-green-500 bg-(--ui-bg)/90 backdrop-blur-sm" :ui="{ root: 'divide-none shadow-xs', body: 'pt-5 px-1.5 pb-1.5 sm:pt-5 sm:px-1.5 sm:pb-1.5' }">
            <div class="px-1.5">
              <div class="grid grid-cols-2 gap-1.5">
                <div>
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-identification" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.name') }}</p>
                  </div>
                  <div v-if="props.supplierLoading" class="flex items-center py-0.5">
                    <UIcon name="i-heroicons-arrow-path" class="w-4 h-4 animate-spin text-gray-400" />
                  </div>
                  <p v-else class="text-sm font-semibold text-gray-900 dark:text-white">{{ supplierDisplayName || '-' }}</p>
                </div>
                <div v-if="props.isPublicView || [Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.CustomerCare, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))">
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-hashtag" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.id') }}</p>
                  </div>
                  <div v-if="props.supplierLoading" class="flex items-center py-0.5">
                    <UIcon name="i-heroicons-arrow-path" class="w-4 h-4 animate-spin text-gray-400" />
                  </div>
                  <p v-else class="text-sm font-mono font-semibold text-gray-900 dark:text-white">{{ supplierDisplayId || '-' }}</p>
                </div>
                <div v-if="dealer" class="col-span-2">
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-home" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.address') }}</p>
                  </div>
                  <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ dealer.street }} {{ dealer.streetNumber }}, {{ dealer.zipCode }} {{ dealer.city }}</p>
                </div>
                <!--
                <div class="col-span-2" v-if="workflow.purchaseOrders?.[purchaseOrderIndex]?.contactEmailForPO && workflow.purchaseOrders?.[purchaseOrderIndex]?.contactEmailForPO.length">
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-at-symbol" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">E-mail</p>
                  </div>
                  <UInputTags
                    v-if="props.isEditMode && [Permission.ClientAccount, Permission.Backoffice, Permission.KeyAccountManager, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))"
                    v-model="workflowEditStore.editableWorkflow.purchaseOrders[purchaseOrderIndex].contactEmailForPO"
                    color="neutral"
                    highlight
                    placeholder=""
                    size="md"
                    class="mt-1"
                    :ui="{ base: 'text-base' }"
                  />
                  <p v-else v-for="(supplierContactEmailAddress, index) in workflowEditStore.editableWorkflow.purchaseOrders[purchaseOrderIndex].contactEmailForPO" :key="index" class="text-sm font-semibold text-gray-900 dark:text-white">
                    {{ supplierContactEmailAddress }}
                  </p>
                </div>
                -->
                <div v-if="[Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.CustomerCare, Permission.PurchaseSupport, Permission.VehicleSupplier, Permission.TyreSupplier, Permission.SupplierSuperUser, Permission.FleetManager].some(p => userStore.hasPermission(p))" class="col-span-2">
                  <div class="flex items-center gap-2 mb-1">
                    <UIcon name="i-heroicons-at-symbol" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                    <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.email') }}</p>
                  </div>
                  <p v-if="workflow?.tenant === Tenant.FI" class="text-sm font-semibold text-gray-900 dark:text-white break-all">
                    {{ primarySupplier?.email || '-' }}
                  </p>
                  <template v-else>
                    <div v-if="props.isEditMode && workflowEditStore.editableWorkflow?.purchaseOrders?.[purchaseOrderIndex] && [Permission.ClientAccount, Permission.Backoffice, Permission.KeyAccountManager, Permission.DeliveryManager, Permission.DeliverySpecialist, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))" class="space-y-2 mt-1">
                      <div v-for="(email, index) in workflowEditStore.editableWorkflow.purchaseOrders[purchaseOrderIndex].contactEmailForPO" :key="index" class="flex items-center gap-2">
                        <span class="text-xs text-gray-500 dark:text-gray-400 min-w-[58px]">{{ t('workflowDetail.supplier.email') }} {{ index + 1 }}</span>
                        <UInput
                          v-model="workflowEditStore.editableWorkflow.purchaseOrders[purchaseOrderIndex].contactEmailForPO[index]"
                          type="email"
                          color="neutral"
                          highlight
                          placeholder=""
                          class="flex-1"
                          :ui="{ base: 'text-sm h-8' }"
                        />
                        <UButton
                          @click="removeSupplierEmail(index)"
                          color="error"
                          variant="ghost"
                          size="sm"
                          icon="i-heroicons-trash"
                        />
                      </div>
                      <UButton
                        @click="addSupplierEmail"
                        color="neutral"
                        variant="outline"
                        size="sm"
                        icon="i-heroicons-plus"
                        class="mt-1"
                      >
                        {{ t('workflowDetail.supplier.addEmailAddress') }}
                      </UButton>
                    </div>

                    <div v-else class="space-y-1 mt-1">
                      <div v-if="workflowEditStore.editableWorkflow?.purchaseOrders?.[purchaseOrderIndex] && workflowEditStore.editableWorkflow.purchaseOrders[purchaseOrderIndex].contactEmailForPO?.length">
                        <p v-for="(supplierContactEmailAddress, index) in workflowEditStore.editableWorkflow.purchaseOrders[purchaseOrderIndex].contactEmailForPO" :key="index" class="text-sm font-semibold text-gray-900 dark:text-white">
                          {{ supplierContactEmailAddress }}
                        </p>
                      </div>
                      <p v-else class="text-sm font-semibold text-gray-900 dark:text-white">
                        -
                      </p>
                    </div>
                  </template>
                </div>
                <div v-if="workflow?.tenant === Tenant.FI && workflow.purchaseOrders?.[purchaseOrderIndex]?.type !== PurchaseOrder.Tyre && (props.isPublicView || [Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.CustomerCare, Permission.PurchaseSupport, Permission.VehicleSupplier, Permission.TyreSupplier, Permission.SupplierSuperUser, Permission.FleetManager].some(p => userStore.hasPermission(p)))" class="col-span-2 mt-1 pt-2 border-t border-green-100 dark:border-green-800/40">
                  <div class="flex items-center gap-2 mb-1.5">
                    <UIcon name="i-heroicons-user-circle" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                    <p class="text-xs font-medium text-gray-700 dark:text-gray-300">{{ t('workflowDetail.supplier.salesPerson') }}</p>
                  </div>
                  <div v-if="props.supplierSalesPersonLoading" class="flex items-center py-0.5">
                    <UIcon name="i-heroicons-arrow-path" class="w-4 h-4 animate-spin text-gray-400" />
                  </div>
                  <div v-else-if="props.supplierSalesPersonError && !props.supplierSalesPerson?.fullName" class="flex items-center gap-2">
                    <UIcon name="i-heroicons-exclamation-triangle" class="w-4 h-4 text-red-500" />
                    <p class="text-sm text-red-500 font-medium">{{ t('workflowDetail.client.serviceUnavailable') }}</p>
                  </div>
                  <div v-else class="grid grid-cols-2 gap-1.5">
                    <div>
                      <div class="flex items-center gap-2 mb-0.5">
                        <UIcon name="i-heroicons-user" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                        <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.name') }}</p>
                      </div>
                      <p class="text-sm font-semibold text-gray-900 dark:text-white break-words">{{ props.supplierSalesPerson?.fullName || '-' }}</p>
                    </div>
                    <div>
                      <div class="flex items-center gap-2 mb-0.5">
                        <UIcon name="i-heroicons-phone" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                        <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.phone') }}</p>
                      </div>
                      <p class="text-sm font-semibold text-gray-900 dark:text-white break-words">{{ props.supplierSalesPerson?.phone || '-' }}</p>
                    </div>
                    <div class="col-span-2">
                      <div class="flex items-center gap-2 mb-0.5">
                        <UIcon name="i-heroicons-envelope" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                        <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.email') }}</p>
                      </div>
                      <p class="text-sm font-semibold text-gray-900 dark:text-white break-all">{{ props.supplierSalesPerson?.email || '-' }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="otherSupplierEntries.length" class="col-span-2 mt-1 pt-2 border-t border-green-100 dark:border-green-800/40">
                  <div class="space-y-2">
                    <div v-for="entry in otherSupplierEntries" :key="entry.poNumber" class="rounded-md bg-green-50/60 dark:bg-green-900/10 ring-1 ring-green-200/60 dark:ring-green-800/40 px-2.5 py-2">
                      <div class="flex items-center gap-1.5 mb-1">
                        <UIcon :name="isVehicleOrderType(entry.poType) ? 'i-mdi-car-hatchback' : 'i-mdi-tire'" :class="isVehicleOrderType(entry.poType) ? 'text-indigo-600 dark:text-indigo-400' : 'text-amber-600 dark:text-amber-400'" class="w-3.5 h-3.5"/>
                        <span class="text-[11px] font-semibold uppercase tracking-wide" :class="isVehicleOrderType(entry.poType) ? 'text-indigo-700 dark:text-indigo-300' : 'text-amber-700 dark:text-amber-300'">{{ getOtherSupplierTypeLabel(entry.poType) }}</span>
                      </div>
                      <div class="grid grid-cols-2 gap-1.5">
                        <div>
                          <div class="flex items-center gap-2 mb-0.5">
                            <UIcon name="i-heroicons-identification" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                            <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.name') }}</p>
                          </div>
                          <p class="text-sm font-semibold text-gray-900 dark:text-white break-words">{{ entry.partner?.name?.trim() || entry.embeddedName || '-' }}</p>
                        </div>
                        <div v-if="props.isPublicView || [Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.CustomerCare, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))">
                          <div class="flex items-center gap-2 mb-0.5">
                            <UIcon name="i-heroicons-hashtag" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                            <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.id') }}</p>
                          </div>
                          <p class="text-sm font-mono font-semibold text-gray-900 dark:text-white">{{ entry.partner?.id || entry.embeddedId || '-' }}</p>
                        </div>
                        <div class="col-span-2">
                          <div class="flex items-center gap-2 mb-0.5">
                            <UIcon name="i-heroicons-at-symbol" class="w-4 h-4 text-green-600 dark:text-green-400"/>
                            <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('workflowDetail.supplier.email') }}</p>
                          </div>
                          <p class="text-sm font-semibold text-gray-900 dark:text-white break-all">{{ entry.partner?.email || '-' }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </UCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from "vue-i18n";
import { type WorkflowDto, PersonPartner, ContactPersonDto, SupplierSalesPersonDto, DriverDto, type CostCenterDto, type OrganizationPartnerDto, type SupplierPartnerDto, BusinessPartnerAddress, WorkflowStatus, QuotationStep, TyreOrderStep, DeliveryStep } from "@/api/eOrdersApi.ts";
import { useWorkflowEdit } from "@/store/workflowEdit";
import { getSapLocalizedText } from "@/utils/sapLocalization";
import { Permission } from "@/types/enums/Permission.ts";
import { Tenant } from "@/types/enums/Tenant.ts";
import { PurchaseOrder, isVehicleOrderType } from "@/types/enums/PurchaseOrder.ts";
import { isNolsQuotation, isCzechiaQuotation, isCzechiaDelivery, isNolsDelivery, isSapOrder, isNolsOrder } from "@/types/discriminators";
import { useUser } from "@/store";
import { formatDate, addBusinessDays } from "@/utils/date.ts";
import { formatPriceWithCurrency } from "@/utils/price.ts";
import { CalendarDate } from '@internationalized/date'
import type { DateValue } from '@internationalized/date'
import { showError, showSuccess } from "@/utils/utils.ts";

type SupplierLike = SupplierPartnerDto | OrganizationPartnerDto;

const props = defineProps<{
  workflow: WorkflowDto | null;
  driver?: DriverDto | null;
  driverLoading?: boolean;
  driverError?: boolean;
  drivers?: PersonPartner[];
  contactPerson?: ContactPersonDto | null;
  contactPersonLoading?: boolean;
  contactPersonError?: boolean;
  costCenter?: CostCenterDto | null;
  costCenterLoading?: boolean;
  costCenterError?: boolean;
  supplierSalesPerson?: SupplierSalesPersonDto | null;
  supplierSalesPersonLoading?: boolean;
  supplierSalesPersonError?: boolean;
  supplier?: SupplierLike | null;
  supplierLoading?: boolean;
  supplierError?: boolean;
  suppliersByPo?: Record<string, SupplierPartnerDto | null>;
  dealer?: BusinessPartnerAddress | null;
  isEditMode: boolean;
  purchaseOrderIndex: number;
  isPublicView?: boolean;
  viewQuotationData?: boolean;
}>();

const { t, locale } = useI18n()
const workflow = computed(() => props.workflow);

const primarySupplier = computed<SupplierLike | null>(() => {
  const wf = workflow.value;
  
  if (!wf) return null;
  
  const currentPo = wf.purchaseOrders?.[props.purchaseOrderIndex];
  
  if (currentPo?.number && props.suppliersByPo) {
    return props.suppliersByPo[currentPo.number] ?? null;
  }
  
  return props.supplier ?? null;
});

const contractCreatedDate = computed<string | undefined>(() => {
  const wf = workflow.value;
  
  if (!wf) return undefined;
  
  if (props.viewQuotationData) return wf.createdDate;
  
  return wf.purchaseOrders?.[props.purchaseOrderIndex]?.createdDate ?? wf.createdDate;
});

const supplierDisplayName = computed(() => {
  const sap = primarySupplier.value?.name?.trim();
  
  if (sap) return sap;
  
  const wf = workflow.value;
  
  if (!wf) return '';
  
  return wf.purchaseOrders?.[props.purchaseOrderIndex]?.supplier?.name || wf.quotation?.dealer?.name || '';
});

const supplierDisplayId = computed(() => {
  if (primarySupplier.value?.id) return primarySupplier.value.id;
  
  const wf = workflow.value;
  
  if (!wf) return '';
  
  return wf.purchaseOrders?.[props.purchaseOrderIndex]?.supplier?.id || wf.quotation?.dealer?.id || '';
});

const otherSupplierEntries = computed(() => {
  const wf = workflow.value;
  
  if (!wf || wf.tenant !== Tenant.FI) return [];
  
  const currentPo = wf.purchaseOrders?.[props.purchaseOrderIndex];
  
  if (!currentPo?.number) return [];
  
  const map = props.suppliersByPo ?? {};
  
  return (wf.purchaseOrders ?? [])
    .filter((po: any) => po?.number && po.number !== currentPo.number)
    .map((po: any) => ({
      poNumber: po.number as string,
      poType: po.type as string | undefined,
      partner: map[po.number as string] ?? null,
      embeddedName: po.supplier?.name as string | undefined,
      embeddedId: po.supplier?.id as string | undefined,
    }));
});

const getOtherSupplierTypeLabel = (poType: string | undefined): string => {
  if (isVehicleOrderType(poType)) return t('workflowDetail.purchaseOrderType.vehicle');
  if (poType === PurchaseOrder.Tyre) return t('workflowDetail.purchaseOrderType.tyre');
  return '';
};

const userStore = useUser();
const workflowEditStore = useWorkflowEdit();

const isQuotationPhase = computed(() => {
  const wf = workflow.value;
  if (!wf) return false;
  
  return wf.status === WorkflowStatus.QuotationApproval || wf.status === WorkflowStatus.QuotationRejection || (wf.status === WorkflowStatus.Rejected && wf.quotation?.currentProcessStep === QuotationStep.Rejected);
});

const finalStatuses: WorkflowStatus[] = [
  WorkflowStatus.Completed,
  WorkflowStatus.Archived,
  WorkflowStatus.Rejected,
  WorkflowStatus.QuotationRejection,
  WorkflowStatus.OrderRejection,
  WorkflowStatus.DeliveryRejection
];

const finalTyreOrderSteps: TyreOrderStep[] = [TyreOrderStep.Delivered, TyreOrderStep.Rejection, TyreOrderStep.Rejected];

const isWorkflowFinal = computed(() => {
  const wf = workflow.value;
  
  if (!wf) return false;
  
  if (finalStatuses.includes(wf.status)) return true;

  const purchaseOrder = wf.purchaseOrders?.[props.purchaseOrderIndex];
  if (!purchaseOrder) return false;

  if (purchaseOrder.type === PurchaseOrder.Tyre) {
    return finalTyreOrderSteps.includes(purchaseOrder.currentProcessStep as TyreOrderStep);
  }
  
  if (isVehicleOrderType(purchaseOrder.type)) {
    return wf.delivery?.currentProcessStep === DeliveryStep.Completed;
  }
  
  return false;
});

const showBenefitInKind = computed(() => {
  if (workflow.value?.tenant !== Tenant.FI) return false;

  const level = props.driver?.benefitLevel;
  if (level !== '01' && level !== '02') return false;

  const bik = workflow.value?.quotation?.benefitInKind;
  if (bik?.fullBenefitValue == null && bik?.limitedBenefitValue == null) return false;

  if ([Permission.VehicleSupplier, Permission.TyreSupplier, Permission.SupplierSuperUser].some(p => userStore.hasPermission(p))) return false;

  return true;
});

const driverBenefitLevelLabel = computed(() => {
  const code = props.driver?.benefitLevel;
  
  if (!code) return '-';
  
  switch (code) {
    case '01': return t('workflowDetail.driver.benefitLevels.limited');
    case '02': return t('workflowDetail.driver.benefitLevels.full');
    default: return code;
  }
});

const parseDateString = (dateStr: string): CalendarDate => {
  const date = new Date(dateStr)
  return new CalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
}

const requestedDeliveryDateValidationError = ref(false);

const isRequiredDeliveryDatePopoverOpen = ref(false)

const requiredDeliveryDateMinDate = new CalendarDate(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate())

const requiredDeliveryDateDisabledDates = (date: DateValue) => {
  const jsDate = new Date(date.year, date.month - 1, date.day);
  const dayOfWeek = jsDate.getDay();

  let isDisabled = dayOfWeek === 0 || dayOfWeek === 6;
  
  if (workflowEditStore.editableWorkflow?.replacedCar?.licensePlate && workflowEditStore.editableWorkflow?.replacedCar?.licensePlate.trim() !== '') {
    const year = date.year;
    const dec15 = new Date(year, 11, 15);
    const dec31 = new Date(year, 11, 31);

    if (jsDate >= dec15 && jsDate <= dec31) {
      isDisabled = true;
    }
  }

  return isDisabled;
}

const requiredDeliveryDate = computed({
  get() {
    const dateString = workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario?.date
    return dateString ? parseDateString(dateString) : null
  },
  set(newDate: CalendarDate) {
    if (newDate && workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario) {
      const { year, month, day } = newDate;
      const localDate = new Date(year, month - 1, day);
      workflowEditStore.editableWorkflow.quotation.requestedDeliveryDateScenario.date = localDate.toISOString().replace('.000Z', 'Z')
    }
    
    if (newDate && workflowEditStore.editableWorkflow?.quotation && !workflowEditStore.editableWorkflow.quotation.requestedDeliveryDateScenario && workflow.value?.tenant === Tenant.FI) {
      const { year, month, day } = newDate;
      const localDate = new Date(year, month - 1, day);
      workflowEditStore.editableWorkflow.quotation.requestedDeliveryDateScenario = { mode: 'GE', date: localDate.toISOString().replace('.000Z', 'Z') }
    }
  }
})

const isDealerExpectedDeliveryDatePopoverOpen = ref(false)
const dealerExpectedDeliveryDateMinDate = new CalendarDate(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate())

const dealerExpectedDeliveryDateDisabledDates = (date: DateValue) => {
  const jsDate = new Date(date.year, date.month - 1, date.day);
  const dayOfWeek = jsDate.getDay();
  
  return dayOfWeek === 0 || dayOfWeek === 6
}

const isExpectedDeliveryDateInvalid = computed(() => {
  if (!dealerExpectedDeliveryDate.value) return false;
  
  const { year, month, day } = dealerExpectedDeliveryDate.value;
  const expectedDate = new Date(year, month - 1, day);
  expectedDate.setHours(0, 0, 0, 0);
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const minBusinessDate = addBusinessDays(today, 7);
  
  if (expectedDate <= minBusinessDate) return true;

  const possibleDeliveryDateStr = workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario?.date;
  
  if (possibleDeliveryDateStr) {
    const possibleDate = new Date(possibleDeliveryDateStr);
    possibleDate.setHours(0, 0, 0, 0);
    
    if (expectedDate < possibleDate) return true;
  }

  return false;
});

const showExpectedDeliveryDateInvalidError = computed(() => {
  return props.isEditMode && workflow.value?.tenant === Tenant.FI && isExpectedDeliveryDateInvalid.value && userStore.hasPermission(Permission.VehicleSupplier) && !userStore.hasPermission(Permission.PurchaseSupport);
});

const dealerExpectedDeliveryDate = computed({
  get() {
    const dateString = workflowEditStore.editableWorkflow?.purchaseOrders?.[props.purchaseOrderIndex]?.dealerExpectedDeliveryDate
    return dateString ? parseDateString(dateString) : null
  },
  set(newDate: CalendarDate) {
    const purchaseOrder = workflowEditStore.editableWorkflow?.purchaseOrders?.[props.purchaseOrderIndex]
    if (newDate && purchaseOrder) {
      const { year, month, day } = newDate
      purchaseOrder.dealerExpectedDeliveryDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    }
  }
})

const isHandoverDatePopoverOpen = ref(false)

const handoverDate = computed({
  get() {
    const dateString = workflowEditStore.editableWorkflow?.delivery?.handoverDate
    return dateString ? parseDateString(dateString) : null
  },
  set(newDate: CalendarDate) {
    if (newDate && workflowEditStore.editableWorkflow?.delivery) {
      const { year, month, day } = newDate
      workflowEditStore.editableWorkflow.delivery.handoverDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    }
  }
})

const showHandoverDateMustBeTodayError = computed(() => {
  if (!props.isEditMode) return false;
  if (workflow.value?.tenant !== Tenant.FI) return false;
  if (!userStore.hasPermission(Permission.VehicleSupplier)) return false;
  if (userStore.hasPermission(Permission.PurchaseSupport)) return false;
  if (!handoverDate.value) return false;
  
  const { year, month, day } = handoverDate.value;
  const selected = new Date(year, month - 1, day);
  selected.setHours(0, 0, 0, 0);
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  return selected.getTime() !== today.getTime();
});

const formatNumber = (number: number) => {
  return new Intl.NumberFormat('cs-CZ').format(number)
}

const addSupplierEmail = () => {
  const po = workflowEditStore.editableWorkflow?.purchaseOrders?.[props.purchaseOrderIndex]

  if (po?.contactEmailForPO) {
    po.contactEmailForPO.push('')
  }
}

const removeSupplierEmail = (index: number) => {
  const po = workflowEditStore.editableWorkflow?.purchaseOrders?.[props.purchaseOrderIndex]
  const emails = po?.contactEmailForPO
  
  if (!emails) return
  emails.splice(index, 1)
  
  if (emails.length === 0) {
    emails.push('')
  }
}

const validateAllFields = () => {
  let isValid = true;

  requestedDeliveryDateValidationError.value = false;

  const deliveryMode = workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario;

  if (deliveryMode?.mode && deliveryMode.mode !== 'ASAP' && !deliveryMode.date) {
    showError(t('notification.requestedDeliveryDateValidationError'))
    requestedDeliveryDateValidationError.value = true;
    isValid = false;
  }
  
  if (showExpectedDeliveryDateInvalidError.value) {
    showError(t('processStatus.expectedDeliveryDateInvalidMessage'))
    isValid = false;
  }
  
  if (showHandoverDateMustBeTodayError.value) {
    showError(t('processStatus.registrationDateMustBeTodayMessage'))
    isValid = false;
  }
  
  return isValid;
};

watch(() => workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario?.mode, (newMode) => {
  if (newMode === 'ASAP') {
    const scenario = workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario;
    if (scenario) {
      scenario.date = null;
    }
  }
});

watch(() => workflowEditStore.editableWorkflow?.replacedCar?.licensePlate, (newValue, oldValue) => {
  const hasValueNow = newValue && newValue.trim() !== '';
  const hadValueBefore = oldValue && oldValue.trim() !== '';

  if (hasValueNow && !hadValueBefore) {
    const scenario = workflowEditStore.editableWorkflow?.quotation?.requestedDeliveryDateScenario;
    if (scenario?.date) {
      const [year, month, day] = scenario.date.split('-').map(Number);
      const jsDate = new Date(year, month - 1, day);
      const dec15 = new Date(year, 11, 15);
      const dec31 = new Date(year, 11, 31);
      
      if (jsDate >= dec15 && jsDate <= dec31) {
        scenario.date = null;
      }
    }
  }
});

defineExpose({
  validateAllFields,
  showExpectedDeliveryDateInvalidError,
  showHandoverDateMustBeTodayError
});
</script>